import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SizeTable } from '../SizeTable';
import { FAQS, SIZE_NOTE, SUPPORT_EMAIL, WHATSAPP_URL } from '../../data/collection';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="preguntas" aria-labelledby="preguntas-title" className="w-full bg-ivory" data-id="element-196" data-mp="us41dbcmsfcn">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 [&>*]:min-w-0 px-5 py-16 sm:px-8 lg:grid-cols-[minmax(0,0.75fr)_minmax(0,1.25fr)] lg:gap-16 lg:py-24" data-id="element-197" data-mp="71zvexbz03ih">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-198" data-mp="gzxi3ge6ls8z">
          <SectionHeading id="preguntas-title" title="Preguntas frecuentes" data-id="element-199" data-mp="gxbajgrajcqr" />
          <p className="mt-4 text-[1.02rem] leading-relaxed text-graphite-soft" data-id="element-200" data-mp="byqabhc1gt2b">
            ¿Te quedó alguna duda?{' '}
            {WHATSAPP_URL ? <>
                Escribinos por{' '}
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="font-bold text-coral-ink underline decoration-coral/40 underline-offset-4 hover:decoration-coral-ink" data-id="element-201" data-mp="1nf6tnlqprtug">
                  WhatsApp
                </a>{' '}
                o a{' '}
              </> : 'Escribinos a '}
            <a href={`mailto:${SUPPORT_EMAIL}`} className="break-all font-bold text-coral-ink underline decoration-coral/40 underline-offset-4 hover:decoration-coral-ink" data-id="element-202" data-mp="3v8vs5d8k6335">
              {SUPPORT_EMAIL}
            </a>
          </p>
        </div>

        <ul className="border-t border-ivory-line" data-id="element-203" data-mp="8234lrt1ib4m">
          {FAQS.map((faq, index) => {
          const expanded = open === index;
          const panelId = `faq-panel-${index}`;
          const buttonId = `faq-button-${index}`;
          return <li key={faq.question} className="border-b border-ivory-line" data-id="element-204" data-mp="3gieorocd533m" data-mpi={index}>
                <h3 data-id="element-205" data-mp="noh9jgzd6aax">
                  <button id={buttonId} type="button" aria-expanded={expanded} aria-controls={panelId} onClick={() => setOpen(expanded ? null : index)} className="flex min-h-[64px] w-full items-center justify-between gap-4 py-4 text-left text-[1.08rem] font-bold text-graphite transition-colors duration-150 ease-out hover:text-coral-ink focus:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-coral/30 sm:text-[1.15rem]" data-id="element-206" data-mp="nnobr5iduv4x">
                    {faq.question}
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${expanded ? 'rotate-45 bg-coral-deep text-white' : 'bg-blush text-coral-ink'}`} data-id="element-207" data-mp="doysb8au92mk">
                      <PlusIcon className="h-4 w-4" strokeWidth={2.5} aria-hidden data-id="element-208" data-mp="1snmj2hcpxby3" />
                    </span>
                  </button>
                </h3>
                <div id={panelId} role="region" aria-labelledby={buttonId} className={`grid transition-[grid-template-rows] duration-200 ease-out ${expanded ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`} data-id="element-209" data-mp="1xl5wjf1ldkoz">
                  <div className="overflow-hidden" hidden={!expanded} data-id="element-210" data-mp="2gdgucuhe2sg8">
                    <div className="max-w-2xl pb-6 sm:pr-10" data-id="element-211" data-mp="2gft8ewk10io0">
                      <p className="pr-10 text-[1.02rem] leading-relaxed text-graphite-soft sm:pr-0" data-id="element-212" data-mp="21o2kzmdtcb0u">{faq.answer}</p>
                      {faq.sizeTable && <div className="mt-4 max-w-md" data-id="element-213" data-mp="2udroc6dzwn5m">
                          <SizeTable compact data-id="element-214" data-mp="2uc6smdfy2y66" />
                          <p className="mt-3 text-[0.95rem] leading-relaxed text-graphite-soft" data-id="element-215" data-mp="2z3ycy68ic7nv">{SIZE_NOTE}</p>
                        </div>}
                    </div>
                  </div>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}